
import { useState, useEffect } from "react";
import TopNavbar from "./Navbar";
import Sidebar from "./Sidebar";

export default function Layout({ children }) {
  const [openSidebar, setOpenSidebar] = useState(false);

  const closeSidebar = () => setOpenSidebar(false);

  useEffect(() => {
    // Initialize theme from localStorage on app start
    const savedTheme = localStorage.getItem("app-theme") || "dark";
    document.documentElement.setAttribute("data-theme", savedTheme);
    document.documentElement.style.colorScheme = savedTheme;
  }, []);

  return (
    <div className="flex h-screen overflow-hidden" style={{ backgroundColor: 'var(--app-bg)', color: 'var(--text)' }}>

      {/* ✅ Sidebar */}
      <div
        className={`fixed inset-y-0 left-0 z-40 transform 
        ${openSidebar ? "translate-x-0" : "-translate-x-full"} 
        md:translate-x-0 transition duration-300 ease-in-out`}
      >
        <Sidebar onNavigate={closeSidebar} />
      </div>

      {/* ✅ Overlay for mobile */}
      {openSidebar && (
        <div
          className="fixed inset-0 z-30 md:hidden"
          style={{ backgroundColor: 'var(--app-bg)' }}
          onClick={closeSidebar}
        />
      )}

      {/* ✅ Main Content */}
      <div className="flex min-w-0 flex-1 flex-col md:ml-64">

        {/* ✅ Navbar */}
        <TopNavbar toggleSidebar={() => setOpenSidebar(!openSidebar)} />

        {/* ✅ Content */}
        <main className="flex-1 overflow-auto p-3" style={{ backgroundColor: 'var(--app-bg)', color: 'var(--text)' }}>
          {children}
        </main>

      </div>
    </div>
  );
}
